import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS, VERIFY_LOGIN_OTP_SUCCESS } from '../types/auth';
import { CREATE_APPLICATION_SUCCESS } from '../types/application';

export type ParamsProps = {
  page: number;
  search: string;
  accountType: string;
  applicationType: string;
  status: string;
  modeOfHolding: string;
  modeOfOnboarding: string;
  distributorId: string;
  applicationSentBack: boolean | null;
  documentSentBack: boolean | null;
  kycModified: string;
  custodian: string;
};

export const initialState: ParamsProps = {
  page: 1,
  accountType: '',
  applicationType: '',
  status: '',
  search: '',
  modeOfHolding: '',
  modeOfOnboarding: '',
  distributorId: '',
  applicationSentBack: null,
  documentSentBack: null,
  kycModified: '',
  custodian: '',
};

function paramsReducer(state = initialState, action: AnyAction): Partial<ParamsProps> {
  switch (action.type) {
    case VERIFY_LOGIN_OTP_SUCCESS: {
      return {
        ...state,
        status:
          action.body.role === 'amcapprover'
            ? 'sent_to_amc_approver,sent_for_document_approval'
            : action.body.role === 'poaapprover'
            ? 'sent_to_poa_approver'
            : action.body.role === 'amcauthorisedsignatory'
            ? 'approved_by_applicant1,approved_by_applicant2,approved_by_applicant3,approved_by_authorised_signatories'
            : '',
      };
    }
    case 'GET_PARAMS_DATA':
      return {
        ...state,
        page: action.paramsObj.page,
        accountType: action.paramsObj.accountType,
        applicationType: action.paramsObj.applicationType,
        status: action.paramsObj.status,
        modeOfHolding: action.paramsObj.modeOfHolding,
        modeOfOnboarding: action.paramsObj.modeOfOnboarding,
        distributorId: action.paramsObj.distributorId,
        search: action.paramsObj.search,
        applicationSentBack: action.paramsObj.applicationSentBack,
        documentSentBack: action.paramsObj.documentSentBack,
        kycModified: action.paramsObj.kycModified,
        custodian: action.paramsObj.custodian,
      };
    case CREATE_APPLICATION_SUCCESS:
    case LOGOUT_SUCCESS: {
      return { ...initialState };
    }
    default:
      return state;
  }
}

export default paramsReducer;
